import script from "./KhongGianLamViec.vue?vue&type=script&setup=true&lang=js"
export * from "./KhongGianLamViec.vue?vue&type=script&setup=true&lang=js"

import "./KhongGianLamViec.vue?vue&type=style&index=0&id=62052f48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62052f48"]])

export default __exports__